<template>
  <div :class="!_isMobile ? 'mt88' : 'warpMt'">
    <YJExperiencePc v-if="!_isMobile"></YJExperiencePc>
    <YJExperienceMobile v-else></YJExperienceMobile>
  </div>
</template>

<script>
  import YJExperiencePc from './pc/YJExperiencePc.vue'
  import YJExperienceMobile from './mobile/YJExperienceMobile.vue'
  export default {
     metaInfo(){
      return {
        meta:[
          {
            name: 'title',
            content: '优加健保健康科技 ( 北京 ) 有限公司'
          },
          {
            name:'keywords',
            content:'优加健康,优加健保健康科技 ( 北京 ) 有限公司,医疗保险,创新医疗险,技术团队'
          },
          {
            name: 'description',
            content: '优加健康 一支既懂医疗又懂保险的专业化团队 针对创新医疗险的产品/服务创新和落地能力,服务覆盖百万人群。 针对商保的医疗式专家型管理服务团队,行业权威协会和专业院校共同培训及认证。 精通健康险及互联网数据运营的产品及技术团队。'
          }
        ]
      }
    },
    data() {
      return {
        _isMobile: false
      }
    },
    components: {
      YJExperiencePc,
      YJExperienceMobile,
    },
    created() {
      this._isMobile = this.$util._isMobile()
    },
  }
</script>

<style lang="less" scoped>
  .madeMobile {
    height: 5.4rem;
  }

  .madePc {
    height: 600px;
  }

  img {
    width: 100%;
    height: 100%;
  }
  .mt88 {
    margin-top: 88px;
  }
  .warpMt{
    margin-top: 1.55rem;
  }
</style>


// WEBPACK FOOTER //
// src/views/YJExperience.vue.vue